export default "/images/vendor/flag-icon-css/flags/1x1/uz.svg?37218829b3a988811a6c668780a30520";